(function() {
  hulk_customer_email = '';
  if(window.formbuilder_customer && window.formbuilder_customer.email){
      hulk_customer_email = window.formbuilder_customer.email
  }
  
   window.GetCorePage = function() {
    var wireframes = document.getElementsByClassName("pxFormGenerator");
    form_url = 'https://formbuilder.hulkapps.com';

    if(wireframes.length > 0){
      for (var i = 0; i < wireframes.length; i++) {
        var is_load_form_iframe = true
        var is_spam_form = false
        curFrame = wireframes[i];
        if (curFrame.id){
          var form_data =  window.hulkFormBuilder.form_data['form_'+curFrame.id];
          if(form_data != undefined){
            window.hulkFormBuilder.shop_id = form_data?.shop_uuid || null;
            window.hulkFormBuilder.shop =  window.hulkFormBuilder.shop_data['shop_'+ window.hulkFormBuilder.shop_id];
          } 
          if(form_data != undefined && window.hulkFormBuilder.shop != undefined && window.hulkFormBuilder.shop?.is_skip_metafield == false &&  window.hulkFormBuilder.shop?.shop_deleted == false && window.hulkFormBuilder.shop?.shop_disabled == false){
            is_spam_form = form_data['is_spam_form']
            const hasImageType = form_data['form_data']['formElements'].some(obj => obj.type === 'image' || obj.type === 'file' || obj.type === 'signature' || obj.type === 'page_break' || obj.type === 'time' || obj.type === 'date' || obj.type === 'newdate' || obj.type === 'phone');
            if((form_data['form_data']['advance_js'] !== undefined && form_data['form_data']['advance_js'] !== '') || (form_data['form_data']['after_submit_script'] !== undefined && form_data['form_data']['after_submit_script'] !== '') || form_data['form_data']['captcha_enable'] == 'yes' || form_data['form_data']['captcha_honeypot'] == 'yes'  || form_data['form_data']['captcha_version_3_enable'] == 'yes' || form_data['form_data']['payment_gateway_integration'] == 'yes' || hasImageType == true || ( form_data['form_data']['no_allow_submission'] != undefined && form_data['form_data']['no_allow_submission'] >= 0) ||   window.hulkFormBuilder.features_data['shop_plan_features'] == undefined){
              is_load_form_iframe  = true
            }else{
              is_load_form_iframe  = false
            }
            console.log("is_load_form_iframe :", is_load_form_iframe)
          }
          if(is_spam_form == false){
            if(is_load_form_iframe){
              var curfrm = document.getElementById('frame_'+curFrame.id);
              var available_iframe = document.getElementById(curFrame.id).innerHTML;
              
              if(available_iframe.indexOf('iframe') === -1){
                    var hulk_regexp = /(?!&)utm_[^=]*=[^&]*(?=)/g;
                    var hulk_utm_matches = location.search.substr(1).match(hulk_regexp);
                    var hulk_utm_params = '';
                    if (hulk_utm_matches != undefined){
                        hulk_utm_params = hulk_utm_matches.join('&');
                    }
                    var hulk_referrer_url = location.href
                    var str = '';
                    if (hulk_utm_params){
                        hulk_utm_params = hulk_utm_params.includes("utm_source") ? hulk_utm_params : 'utm_source=hulkapps-form-builder-app&'+hulk_utm_params
                        str = hulk_customer_email ? '<iframe src="' + form_url + '/corepage/customform?id=' + curFrame.id +'&referrer_url='+hulk_referrer_url+'&'+ hulk_utm_params +'&customer_email='+hulk_customer_email+'"  id="frame_' + curFrame.id + '" frameborder="0" width="100%">' : '<iframe src="' + form_url + '/corepage/customform?id=' + curFrame.id +'&referrer_url='+hulk_referrer_url+'&'+ hulk_utm_params +'"  id="frame_' + curFrame.id + '" frameborder="0" width="100%">';
                    }else{
                        str = hulk_customer_email ? '<iframe src="' + form_url + '/corepage/customform?id=' + curFrame.id +'&referrer_url='+hulk_referrer_url+'&customer_email='+hulk_customer_email+'"  id="frame_' + curFrame.id + '" frameborder="0" width="100%">' : '<iframe src="' + form_url + '/corepage/customform?id=' + curFrame.id +'&referrer_url='+hulk_referrer_url+'" id="frame_' + curFrame.id + '" frameborder="0" width="100%">';
                    }
                    document.getElementById(curFrame.id).innerHTML = str ;
              }
              frame_resize(curFrame.id);
            } else {
              hulkFBFontAwesomeScript();
              hulkFBFormLayout(form_data['form_data'], form_data['uuid'], curfrm);
              hulkFBAddtionalFormJS(form_data['form_data'],form_data['uuid'])
              hulkFBPopulateCountryDropdowns();
              hulkFBHandleAnalyticsIntegrationsScript(form_data['form_data']);    
            }
          }
        }  
      }
    }

    function frame_resize(id){
      var iframes = document.getElementsByClassName("pxFormGenerator");
      if(iframes.length > 0){
        for (var i = 0; i < iframes.length; i++) {  
          var width = document.getElementById(id).style.width;
          var formId = id;
          var divId = 'frame_'+id;
          var zino_resize = function (event) {
              if (event.origin !== form_url) {
                  return;
              }
              var zino_iframe = document.getElementById(divId);
              if (zino_iframe) {
                if(event.data['formid'] == formId){
                  if(window.FbThemeAppExtSettingsHash){
                    zino_iframe.contentWindow.postMessage(JSON.stringify(window.FbThemeAppExtSettingsHash),'*');
                  }
                  zino_iframe.style.height = event.data['height'] + "px";
                  if(event.data['scroll_to'] == true){
                      const formElement = document.querySelector('#frame_' + formId);
                      const formRect = formElement.getBoundingClientRect();
                      const targetOffset = formElement.offsetTop > 0 ? formElement.offsetTop - 50 : 0.80 * (formRect.top + window.scrollY);
                      const duration = 1000;
                      const startTime = performance.now();
                      const startScrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

                      function scrollToTarget(currentTime) {
                          const elapsed = currentTime - startTime;
                          const progress = Math.min(elapsed / duration, 1);
                          const easing = easeInOutCubic(progress);
                          const scrollOffset = startScrollOffset + (targetOffset - startScrollOffset) * easing;

                          window.scrollTo(0, scrollOffset);

                          if (elapsed < duration) {
                              requestAnimationFrame(scrollToTarget);
                          }
                      }

                      function easeInOutCubic(t) {
                          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                      }

                      requestAnimationFrame(scrollToTarget);
                  }
                }
              }
          };
          if (window.addEventListener) {
              window.addEventListener("message", zino_resize, false);
          } else if (window.attachEvent) {
              window.attachEvent("onmessage", zino_resize);
          } 
        }
      }
    }
  }

  //GetCorePage();
})();  

if (typeof document !== 'undefined') {
  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.pxFormGenerator')) {
      const assets = window.hulkFormBuilder.assets || {};
      
      if (assets.extraStyles) {
        const extraStyles = document.createElement('link');
        extraStyles.rel = 'stylesheet';
        extraStyles.href = assets.extraStyles;
        document.head.appendChild(extraStyles);
      }

      if (assets.bootstrapStyles) {
        const bootstrapStyles = document.createElement('link');
        bootstrapStyles.rel = 'stylesheet';
        bootstrapStyles.href = assets.bootstrapStyles;
        document.head.appendChild(bootstrapStyles);
      }

      if (assets.extraFunctions) {
        const extraScript = document.createElement('script');
        extraScript.src = assets.extraFunctions;
        extraScript.onload = function () {
          if (typeof GetCorePage === 'function') GetCorePage();
          if (typeof hulkFBInitFormBuilder === 'function') hulkFBInitFormBuilder();
          if (typeof hulkFBKeyboardAccess === 'function') hulkFBKeyboardAccess();
        };
        extraScript.onerror = function () {
          console.error('Failed to load extra-functions.js');
        };
        document.body.appendChild(extraScript);
      }
    }
  });
}